import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestorationDbService {

  /**
  * Url to get customer codes by customer
  */
	public API_LIST_RESTORATION_DB = environment.ipserver + 'o2c-backend/private/restorationDB/list';

  constructor(private http: HttpClient) { }

  /**
    * Get restore date
    * @author Castor Transformación Digital - Ana Quiñones
    * @since 2024-03-20
  */
  public getRestorationDate(): Observable<string> {
    const token = localStorage.getItem('authce9d77b308c149d5992a80073637e4d5');

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get(this.API_LIST_RESTORATION_DB, { headers, responseType: 'text' });
  }
}
